/* eslint-disable */
import '../../blocks/hero/hero';
import '../../blocks/highlighted-product/highlighted-product';